import Counter from "@/components/site/Counter";
import { useReveal } from "@/hooks/useReveal";
import { Clock3, Truck, Users, MapPin } from "lucide-react";

const STATS = [
  { icon: Clock3, to: 25, suffix: " min", label: "Avg. response window", testId: "stat-response" },
  { icon: Truck, to: 3200, suffix: "+", label: "Recoveries completed", testId: "stat-jobs" },
  { icon: Users, to: 98, suffix: "%", label: "Repeat & referral rate", testId: "stat-repeat" },
  { icon: MapPin, to: 7, suffix: "", label: "Eastside cities covered", testId: "stat-cities" },
];

export default function Stats() {
  const ref = useReveal();
  return (
    <section
      className="relative bg-black py-20 sm:py-24 overflow-hidden"
      data-testid="stats-section"
    >
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 opacity-40"
        style={{
          background:
            "linear-gradient(180deg, rgba(250,204,21,0.06) 0%, rgba(0,0,0,0) 60%)",
        }}
      />
      <div className="pointer-events-none absolute inset-0 bm-grain" />
      <div ref={ref} className="lux-reveal relative max-w-7xl mx-auto px-4 sm:px-6">
        <div className="max-w-3xl">
          <div className="font-display uppercase tracking-[0.32em] text-yellow-400 text-xs flex items-center gap-2">
            <span className="inline-block h-1.5 w-6 bg-yellow-400 rounded-full" />
            By the Numbers
          </div>
          <h2 className="mt-3 font-display font-black uppercase text-white text-3xl sm:text-4xl lg:text-5xl leading-[0.95] tracking-tight">
            Built on <span className="text-yellow-400">trust</span>, measured in <span className="lux-chrome">minutes</span>.
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {STATS.map((s, i) => (
            <div
              key={s.label}
              data-testid={s.testId}
              className={`lux-card lux-glass rounded-2xl p-6 sm:p-8 relative overflow-hidden lux-reveal lux-reveal-delay-${(i % 4) + 1}`}
            >
              <div
                aria-hidden="true"
                className="pointer-events-none absolute -top-16 -right-16 w-40 h-40 rounded-full opacity-30"
                style={{ background: "radial-gradient(circle, rgba(250,204,21,0.4) 0%, rgba(0,0,0,0) 70%)" }}
              />
              <s.icon
                className="h-6 w-6 text-yellow-400 mb-4"
                strokeWidth={2}
                aria-hidden="true"
              />
              <div className="font-display font-black text-white text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-none">
                <Counter
                  to={s.to}
                  suffix={s.suffix}
                  duration={1600}
                  testId={`${s.testId}-value`}
                />
              </div>
              <div className="mt-3 text-zinc-400 text-xs sm:text-sm font-light leading-snug uppercase tracking-widest">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
